import { LucideProps } from 'lucide-react'

const Pie99 = (props: LucideProps) => (
  <svg
    viewBox="0 0 75 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="37.13" cy="37.2316" r="37.13" fill="#42946A" />
    <path d="M37.1328 0V39.3107L43.0601 0H37.1328Z" fill="#fbf9f7" />
  </svg>
)

export default Pie99
